import * as React from "react";

import classNames from "classnames";

import DocBookmark from "../BlockNodeHelpers/Bookmark";
import DocNote from "../BlockNodeHelpers/Note";
import PdfViewerIframe from "../BlockNodeHelpers/PdfViewerIframe";
import DocStyledText from "../BlockNodeHelpers/StyledText";

import GenButton from "../../Gen/Button/component";

import { MEDIA_PICKER } from "../../../helpers/Doc/menu";
import { OPENED_MOD_MAP_LOG } from "../../../helpers/DocumentUserLog";

import PlaceholderImage from "images/placeholder-pdf.png";

interface DocPdfProps extends DocPdfType<InlineNode>, BlockNodeAll {}

function DocPdf(props: DocPdfProps) {
  const { editingContext } = props;

  const openPicker = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();
    if (editingContext.isEditing) {
      editingContext.setCurrentMenu(MEDIA_PICKER, {
        mediaType: "pdf",
        uid: props.uid,
      });
    }
  };

  let title = null;
  if (
    (typeof props.title === "string" && props.title.length > 0) ||
    editingContext.isEditing
  ) {
    title = (
      <figcaption>
        <DocStyledText
          uid={props.uid}
          content={props.title}
          contentKey={"title"}
          editingContext={editingContext}
          placeholder={"Enter Pdf text here"}
          independentlyEditable
          disableStyleTextEditing={props.disableStyleTextEditing}
        />
      </figcaption>
    );
  }

  const url = props.url;

  return (
    <div
      id={props.uid}
      data-is-node
      data-uid={props.uid}
      className={classNames("doc-pdf", props.uid, {
        "focused-bookmark": props.isFocusedBookmark && !props.simple,
      })}
      contentEditable={false}
    >
      <div className={`doc-pdf-wrapper ${url ? "with-pdf" : ""}`}>
        {url ? (
          <>
            <PdfViewerIframe
              src={url}
              width="100%"
              height="100%"
            />
            <a
              href={url}
              target="_blank"
              title="Open in New Tab"
              className="doc-pdf-external-link-button"
            >
              <i className="fa fa-external-link-alt" aria-hidden="true"> </i>
            </a>
          </>
        ) : (
          <img
            src={PlaceholderImage}
            alt="placeholder image"
            style={{ width: "360px" }}
          />
        )}

        {editingContext.isEditing &&
          props.userContext.permissions.viewMediaAssets && (
            <GenButton
              key="picker-button"
              className="doc-pdf-picker-button"
              name={<i className="fa fa-file-pdf"></i>}
              highlighted
              small
              onClick={openPicker}
            />
          )}
      </div>
      {title}
      <DocNote {...props} />
      <DocBookmark {...props} />
    </div>
  );
}

export default React.memo(DocPdf);
